module.exports = "<p>callback works!</p>\n"